import React, { useEffect, useRef, useState } from 'react';
import { TextField } from '@mui/material';

const ControlledTableTextInput = ({ key_name, excel_row, text_value, on_change_handler, state, label }) => {
  const [value, set_value] = useState(text_value || "");
  const timeout = useRef(null);
  const [e, set_e] = useState(null);
  const handle_change = (e) => {
    set_value(e.target.value);
    set_e(e);
  };

  useEffect(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    if (e) {
      timeout.current = setTimeout(() => {
        on_change_handler(e, state, excel_row, excel_row.id, key_name, e.target.value);
        set_e(null);
      }, 1500);
    }
    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [e]);
  return (
    <TextField
      fullWidth
      label={label || "Input"}
      value={value || ""}
      onChange={(e) => {
        // on_change_handler(e, state, excel_row, excel_row.id, key_name, e.target.value);
        handle_change(e);
      }}
    />
  );
};

export default ControlledTableTextInput;
